import { memo } from 'react'

import type { CareSymbol as CareSymbolType } from '../../../types/product'

type CareSymbolProps = {
  contentOne?: string
  contentTwo?: CareSymbolType[]
}

const CareSymbol = ({ contentOne, contentTwo }: CareSymbolProps) => {
  return (
    <>
      <article
        data-testid="productDocuments"
        className="productManualAndDocs
                w-full
                flex flex-col bg-white items-left mt-8
                justify-between px-6 py-4"
      >
        <h4 className="text-[22px] leading-[118.18%] font-inter color-[#101010] pb-4 font-semibold">
          Cuidados
        </h4>
        {contentOne && (
          <>
            <h5 className="text-font-size-4 font-inter color-[#101010] pb-2 font-semibold">
              Armazenamento
            </h5>
            <p className="text-font-size-4 font-inter text-tertiary mb-8">
              {contentOne}
            </p>
          </>
        )}

        {contentTwo && (
          <>
            <h5 className="text-font-size-4 font-inter color-[#101010] pb-4 font-semibold">
              Limpeza
            </h5>
            <div>
              {contentTwo.map((item) => (
                <div
                  key={item.name}
                  className="flex flex-row items-center justify-start py-1 h-8"
                >
                  <img
                    height={32}
                    width={32}
                    src={item.imageUrl}
                    alt={item.name}
                    loading="lazy"
                  />
                  <p className="text-font-size-4 font-inter text-tertiary pl-2">
                    {item.name}
                  </p>
                </div>
              ))}
            </div>
          </>
        )}
      </article>
    </>
  )
}

export default memo(CareSymbol)
